import { Box } from '@mui/material';

import { SqlSection } from './SqlSection/SqlSection';

/**
 * SQL tab body for the gen-3 cohort detail page (M4 workspace design —
 * SQL is a sibling tab of Definition and Results, no longer a section
 * nested inside the Definition tab).
 *
 * Same gutters as the Definition tab so the card lines up with the
 * header and tabs across tab switches.
 */
export const SqlTab = () => {
  return (
    <Box
      data-testid="cohort-detail-sql-tab"
      sx={{
        width: '100%',
        minHeight: 0,
        paddingX: 6,
        paddingY: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
    >
      <SqlSection />
    </Box>
  );
};
